import { SelectedViewsActions } from './constants';

export const setSelectedView = (view: 'album-content' | 'album-covers') => ({
  type: SelectedViewsActions.SET_SELECTED_VIEW,
  payload: view,
});
